<template>
  <div
    id="createSigningModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">新增電子簽單</h3>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row space">
            <h4 class="col-md-2">企業＊:</h4>
            <div class="col-md-6">
              <select class="form-control" required="" v-model="enterpriceId">
                <option :value="0">不選擇</option>
                <option v-for="company in companyList" :value="company.id">
                  {{ company.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="row space">
            <h4 class="col-md-2">司機＊:</h4>
            <InputAutocomplete
              ref="inputDriverAutocomplete"
              @handleSelect="handleSelect"
            ></InputAutocomplete>
          </div>
          <div class="row space">
            <h4 class="col-md-3">補單日期</h4>
            <input
              type="datetime-local"
              class="inputstyle fontSize16 col-md-9 col-sm-9 col-xs-9"
              v-model="replenishmentAt"
            />
          </div>
          <div class="row space">
            <h4 class="col-md-3">員工工號＊</h4>
            <input
              type="text"
              class="inputstyle fontSize16 col-md-9 col-sm-9 col-xs-9"
              v-model="employeeNumber"
            />
          </div>
          <div class="row space">
            <h4 class="col-md-3">上車地點＊</h4>
            <input
              type="text"
              class="inputstyle fontSize16 col-md-9 col-sm-9 col-xs-9"
              v-model="onAddress"
            />
          </div>
          <div class="row space">
            <h4 class="col-md-3">下車地點＊</h4>
            <input
              type="text"
              class="inputstyle fontSize16 col-md-9 col-sm-9 col-xs-9"
              v-model="offAddress"
            />
          </div>
          <div class="row space">
            <h4 class="col-md-3">司機車資＊</h4>
            <input
              type="number"
              class="inputstyle fontSize16 col-md-9 col-sm-9 col-xs-9"
              v-model="actualFare"
            />
          </div>
          <div class="row space">
            <h4 class="col-md-3">服務費＊</h4>
            <input
              type="number"
              class="inputstyle fontSize16 col-md-9 col-sm-9 col-xs-9"
              v-model="serviceFare"
            />
          </div>
          <div class="row space">
            <h4 class="col-md-3">乘客備註</h4>
            <input
              type="text"
              class="inputstyle fontSize16 col-md-9 col-sm-9 col-xs-9"
              v-model="note"
            />
          </div>
          <div class="row space">
            <h4 class="col-md-3">客服備註(補單原因)＊</h4>
            <input
              type="text"
              class="inputstyle fontSize16 col-md-9 col-sm-9 col-xs-9"
              v-model="serviceNote"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            關閉
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            @click="createSigningInfo"
          >
            儲存
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import API from '@/assets/js/libs/API'
import EnterpriseAPI from '@/assets/js/libs/EnterpriseAPI'
import { Notification } from 'element-ui'
import InputAutocomplete from '@/components/element_ui/InputAutocomplete'

export default {
  components: {
    InputAutocomplete,
  },
  data() {
    return {
      enterpriceId: 0,
      driverId: 0,
      replenishmentAt: null,
      employeeNumber: '',
      onAddress: '',
      offAddress: '',
      actualFare: 0,
      serviceFare: 0,
      note: '',
      serviceNote: '',
      enterpriseSignId: '',
      transactionId: 0,
      reservationId: 0,
      kw: '',
      driverList: [],
      enterpriceName: [],
      companyList: [],
    }
  },
  mounted() {
    EnterpriseAPI.get(`enterprise/`)
      .then((res) => {
        this.companyList = res.result.list
      })
      .catch((err) => {
        console.log(err)
      })
  },
  methods: {
    handleSelect(val) {
      this.driverId = val.id
    },
    searchKeyWord() {
      API.get(`driver-v2/list?task=search&kw=${this.kw}`)
        .then((res) => {
          this.driverList = res.result.driverList
        })
        .catch((err) => {
          this.$msg('網路連線異常')
        })
    },
    validationText() {
      if (this.enterpriceId === 0) return '請輸入企業'
      if (this.driverId === 0) return '請輸入司機'
      /* if (!this.replenishmentAt) return '請輸入補單日期' */
      if (this.employeeNumber === '') return '請輸入員工工號'
      if (this.onAddress === '') return '請輸入上車地點'
      if (this.offAddress === '') return '請輸入下車地點'
      if (this.actualFare === 0) return '請輸入司機車資'
      if (this.serviceNote === '') return '請輸入客服備註'
      return null
    },
    createSigningInfo() {
      if (!this.validationText()) {
        const payload = {
          enterpriseId: this.enterpriceId,
          driverId: this.driverId,
          replenishmentAt: this.replenishmentAt,
          employeeNumber: this.employeeNumber,
          onAddress: this.onAddress,
          offAddress: this.offAddress,
          actualFare: this.actualFare,
          serviceFare: this.serviceFare,
          member: 1,
        }
        if (this.note !== '') payload.note = this.note
        if (this.serviceNote !== '') payload.serviceNote = this.serviceNote

        EnterpriseAPI.post(`enterprise/signing/create`, payload)
          .then((res) => {
            if (res.success) {
              $('#createSigningModal').modal('hide')
              this.$emit('updateSigningList', '')
              Notification({
                type: 'success',
                message: '新增成功',
              })
            } else {
              Notification({
                type: 'error',
                message: '新增失敗',
              })
            }
          })
          .catch((e) => {
            console.error(e)
            Notification({
              type: 'error',
              message: '新增失敗，請再試一次',
            })
          })
      } else {
        Notification({
          type: 'error',
          message: this.validationText(),
        })
      }
    },
    clearInformation() {
      this.enterpriceId = 0
      this.driverId = 0
      this.replenishmentAt = null
      this.employeeNumber = ''
      this.onAddress = ''
      this.offAddress = ''
      this.actualFare = 0
      this.serviceFare = 0
      this.serviceNote = ''
      this.note = ''
      this.kw = ''
      this.driverList = []
      this.$refs.inputDriverAutocomplete.clearSelect()
    },
    showModal() {
      this.clearInformation()
      $('#createSigningModal').modal('show')
    },
  },
}
</script>

<style scoped>
.space {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/company/CreateSigningModal.vue